import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactGA from 'react-ga'

import './styles.scss'
import { Plann3rStore } from '../../../../store/types'
import { nextStep } from '../../../../store/onboarding/actions'
import { Routes } from '../../../../routing/routes'
import { Link } from 'react-router-dom'

const Completed: FC = () => {
  ReactGA.event({
    category: 'Onboarding',
    action: 'Step 6',
  })

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.onboarding.completed,
  )

  const dispatch = useDispatch()

  return (
    <div className="onboarding_box">
      <div className="onboarding_content completed">
        <h2 className="has-text-centered">{strings.last_step}</h2>
        <p>{strings.ready}</p>
        <button
          className="button is-secondary"
          onClick={() => dispatch(nextStep())}
        >
          {strings.i_want}
        </button>
        <Link to={Routes.SETTINGS}>{strings.settings_2}</Link>
      </div>
    </div>
  )
}

export default Completed
